import {
    REQUIREMENT_IRRELEVANT,
    REQUIREMENT_9_CLASS,
    REQUIREMENT_11_CLASS,
} from '../constants/requirements';

export const configRequirementsTranslateMap = {
    [REQUIREMENT_IRRELEVANT]: 'no_special_requirements',
    [REQUIREMENT_9_CLASS]: 'based_on_9_classes',
    [REQUIREMENT_11_CLASS]: 'based_on_11_classes',
};
